import { IRegistration } from '../../../api/workshopRegistrations';
import { BiSort } from 'react-icons/bi';
import { CheckBox } from '@wot/components';
import { useNavigate } from 'react-router-dom';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../components/Table';
import TableRowItem from './TableRowItem';

interface Props {
  data: IRegistration[];
  handleSort: (key: string) => void;
  selectedIds: Set<string>;
  onSelect: (id: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

export default function TableContainer({ data, handleSort, selectedIds, onSelect, onSelectAll }: Props) {
  const navigate = useNavigate();
  const allSelected = data.length > 0 && data.every((e) => selectedIds.has(e._id));

  return (
    <Table>
      <TableHeading>
        <TableRow>
          <th className="w-12 px-4 py-2" onClick={(e) => e.stopPropagation()}>
            <CheckBox defaultValue={allSelected} onChange={onSelectAll} />
          </th>
          <TableHeadingCol
            label="DATE"
            component={
              <div className="flex items-center">
                <p>DATE</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('createdAt')}
          />
          <TableHeadingCol label="STUDENT" />
          <TableHeadingCol label="PARENT" />
          <TableHeadingCol label="EMAIL" />
          <TableHeadingCol label="PHONE" />
          <TableHeadingCol label="WORKSHOP" />
          <TableHeadingCol label="CLASS" />
          <TableHeadingCol label="AMOUNT" />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((registration) => (
          <TableRow key={registration._id} onClick={() => navigate(registration._id)}>
            <TableRowItem registration={registration} selected={selectedIds.has(registration._id)} onSelect={onSelect} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
